import login from './login';
import loginBasic from './loginBasic';
import getRole from './getRole';
import getDomain from './getDomain';
import register from './register';
import getShortcutMenuList from './getShortcutMenuList';
import delShortcutMenu from './delShortcutMenu';
import saveShortcutMenu from './saveShortcutMenu';

export default {
  login,
  loginBasic,
  getRole,
  getDomain,
  register,
  getShortcutMenuList,
  saveShortcutMenu,
  delShortcutMenu
};


// WEBPACK FOOTER //
// ./src/api/system/index.ts